export default async () => {
  const entries = document.querySelectorAll('.js-del-headerProductsWrapper');
  if (entries.length > 0) {
    const controller = await import(
      /* webpackChunkName: "DELHeaderProductsSliderController-lib" */ '@/delonghi/Controllers/DELHeaderProductsSlider/DELHeaderProductsSliderController'
    );
    controller.default();
  }
};
